import React from 'react';
import { Button } from 'semantic-ui-react';
import './ToggleButtonGroup.css'; // Import the CSS file

/**
 * ToggleButtonGroup is a reusable component that renders a group of toggle buttons or a simple enable/disable toggle.
 * @param {array} options - The options for the toggle buttons. Each option should have a `key`, `text`, and `value`.
 * @param {string} activeValue - The currently active value.
 * @param {function} onChange - The function to handle the change when a button is clicked.
 * @param {boolean} isSimpleToggle - If true, renders a simple enable/disable toggle.
 * @param {boolean} isEnabled - The current state of the simple toggle (enabled or disabled).
 * @param {function} onToggle - The function to handle the toggle state change.
 * @param {boolean} isReadOnly - If true, disables the toggle interaction.
 * @param {string} className - Additional class names for styling the button group.
 * @param {string} dataCy - The data-cy attribute for Cypress testing.
 **/

const ToggleButtonGroup = ({
  options,
  activeValue,
  onChange,
  isSimpleToggle = false,
  isEnabled,
  onToggle,
  isReadOnly = false,
  className,
  dataCy,
  disabled
}) => {
  // Detect if this is the Agentic QnA toggle in RetrievalParameter by className
  const isAgenticQnA = className && className.includes('agenticqna-toggle');

  if (isSimpleToggle) {
    return (
      <div className={`toggle-item ${className}`} data-cy={dataCy}>
        <img
          src={
            isAgenticQnA && isEnabled
              ? "/images/agentic-enable.svg"
              : isEnabled
                ? "/images/enable.svg"
                : "/images/disable.svg"
          }
          alt={isEnabled ? "Enabled" : "Disabled"}
          onClick={(e) => {
            if (!disabled && !isReadOnly) {
              e.stopPropagation();
              onToggle();
            }
          }}
          className={`toggle-icons ${disabled || isReadOnly ? "disabled" : ""}`}
        />
      </div>
    );
  }

  return (
    <Button.Group className={`toggle-button-group ${className}`} data-cy={dataCy}>
      {options.map((option) => (
        <Button
          key={option.key}
          toggle
          active={activeValue === option.value}
          onClick={() => onChange(option.value)}
          data-cy={`${dataCy}-${option.key}`}
          disabled={disabled}
        >
          {option.text}
        </Button>
      ))}
    </Button.Group>
  );
};

export default ToggleButtonGroup;